export default "__VITE_ASSET___E6oWlfo__"